var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('List',{attrs:{"listing":"conversation","fields":_vm.fields,"order-by":"created_at: desc","search-text":"Rechercher une conversation","pageSize":_vm.pageSize,"edit-route-name":"conversation-edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }